import { producaov2 as api } from "../../services/apis";
import { retira_acentos } from "../Utils";

export const uploadImage = async (file, basePath, arrayTypes) => {
  if (!arrayTypes.includes(file.type)) {
    return {
      status: false,
      message: `A imagem do tipo ${file.type} não é permitido`,
    };
  }

  const data = new FormData();
  const nameFile = clearNomeCapa(file.name);

  data.append("file", file);
  data.append("nome", nameFile);
  data.append("path", basePath);

  return await api
    .post("/upload", data)
    .then((res) => {
      return {
        status: res.status === 200 ? true : false,
        message: res.data.url,
      };
      console.log(res);
    })
    .catch((err) => {
      return {
        status: false,
        message: `Erro no upload de imagem !`,
      };
    });
};

export const clearNomeCapa = (nome) => {
  let cleanedName = nome.replace(/  */g, "-");
  cleanedName = cleanedName.replace(/\+ */g, "");
  cleanedName = cleanedName.replace(/\(/g, "");
  cleanedName = cleanedName.replace(/\)/g, "");
  cleanedName = cleanedName.replace(/.jpg/, "");
  cleanedName = cleanedName.replace(/.jpeg/, "");
  cleanedName = cleanedName.replace(/.png/, "");
  cleanedName = cleanedName.replace(/.webp/, "");
  cleanedName = cleanedName.replace(/\./g, "");

  cleanedName = cleanedName.toLowerCase();
  cleanedName = retira_acentos(cleanedName);

  return cleanedName;
};
